import { USER_DATA_API } from "../../apiList";

export default class VendorRoleGateway {
    getVendorRoles() {
        return USER_DATA_API.get("/static-types");
    }
}
